import features from './features.json';

/**
 * The feature switches in features.json, by name. The type is derived from the
 * file, so a component asking about a feature the file does not list is a
 * compile error rather than a silent "off".
 */
export type FeatureName = keyof typeof features.features;

export const FEATURE_NAMES = Object.keys(features.features) as FeatureName[];

/**
 * Whether this build ships a feature's inputs and controls. Only `true` counts;
 * anything else, including a missing entry, is off.
 */
export function isFeatureEnabled(name: FeatureName): boolean {
  return features.features[name] === true;
}

/**
 * The chapter timeline ("Your plan, year by year") is being iterated on live;
 * until it is ready for everyone it is shown only to these accounts, on top of
 * the `planNarrative` flag. Hard-coded on purpose — the server applies the
 * same list to the narrative endpoint, so nobody else can see or trigger it.
 */
export const PLAN_NARRATIVE_PREVIEW_EMAILS = ['paul@pdfreeman.com'] as const;

export function canPreviewPlanNarrative(email: string | null | undefined): boolean {
  return !!email && (PLAN_NARRATIVE_PREVIEW_EMAILS as readonly string[]).includes(email.trim().toLowerCase());
}
